import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const AdminTabSkeleton = () => (
  <div className="space-y-6">
    <div className="flex justify-between items-center">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-[32px] w-[190px]" />
        <Skeleton className="h-[24px] w-[350px]" />
      </div>

      <Skeleton className="h-10 w-[190px]" />
    </div>

    <div className="flex flex-col gap-4">
      {[...Array(4)].map((_, i) => (
        <Card className="p-6 h-[120px] flex flex-col gap-2" key={`header-${i}`}>
          <Skeleton className="h-6 w-[150px]" />
          <Skeleton className="h-5 w-[200px]" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Skeleton className="h-5 w-[200px]" />
            <Skeleton className="h-5 w-[200px]" />
            <Skeleton className="h-5 w-[200px]" />
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export default AdminTabSkeleton;
